import Vue from 'vue';
import Router from 'vue-router';
import Main from './components/Main.vue';
import About from './components/About.vue';
import Legal from './components/Legal.vue';
import SelectedElement from './components/SelectedElement.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH || '/',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      path: '/',
      component: Main,
    },
    {
      path: '/about',
      component: About,
    },
    {
      path: '/legal',
      component: Legal,
    },
    {
      path: '/:element',
      component: SelectedElement,
    },

    {
      path: '*',
      redirect: '/404',
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router.ts